module.exports = __webpack_public_path__ + "static/media/woman.967abca9.svg";